import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Input } from '../ui/input';
import { Lock, Crown, Filter } from 'lucide-react';

const ALL = '__all__';

export const ZoneFilters = ({ access, loggedIn, filters, onChange, provinces, statuses, total }) => (
  <Card data-testid="zone-filters">
    <CardContent className="p-5 space-y-4">
      <h3 className="font-heading font-bold text-lg flex items-center gap-2"><Filter className="w-5 h-5" /> Filtres</h3>
      {!access && (
        <div className="rounded-md bg-[#F59E0B]/10 border border-[#F59E0B]/30 p-3 text-xs text-[#92400E] flex gap-2" data-testid="zone-filters-locked">
          <Lock className="w-4 h-4 flex-shrink-0 mt-0.5" />
          <span>Les filtres par province et période, l'historique 12 mois, le détail complet et l'export sont réservés aux abonnés Premium.</span>
        </div>
      )}
      <div className={!access ? 'opacity-50 pointer-events-none' : ''}>
        <label className="text-sm font-medium mb-1 block">Province</label>
        <Select value={filters.province || ALL} onValueChange={(v) => onChange('province', v === ALL ? '' : v)}>
          <SelectTrigger data-testid="zone-filter-province"><SelectValue placeholder="Toute la Wallonie" /></SelectTrigger>
          <SelectContent>
            <SelectItem value={ALL}>Toute la Wallonie</SelectItem>
            {provinces.map((p) => <SelectItem key={p} value={p}>{p}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
      <div className={!access ? 'opacity-50 pointer-events-none' : ''}>
        <label className="text-sm font-medium mb-1 block">Période</label>
        <Select value={String(filters.months)} onValueChange={(v) => onChange('months', Number(v))}>
          <SelectTrigger data-testid="zone-filter-months"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="3">3 derniers mois</SelectItem>
            <SelectItem value="6">6 derniers mois</SelectItem>
            <SelectItem value="12">12 derniers mois</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div className={!access ? 'opacity-50 pointer-events-none' : ''}>
        <label className="text-sm font-medium mb-1 block">Type</label>
        <Select value={filters.status || ALL} onValueChange={(v) => onChange('status', v === ALL ? '' : v)}>
          <SelectTrigger data-testid="zone-filter-status"><SelectValue placeholder="Tous" /></SelectTrigger>
          <SelectContent>
            <SelectItem value={ALL}>Tous les types</SelectItem>
            {statuses.map((s) => <SelectItem key={s.id} value={s.id}>{s.label}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
      <div className={!access ? 'opacity-50 pointer-events-none' : ''}>
        <label className="text-sm font-medium mb-1 block">Commune</label>
        <Input placeholder="Ex. Arlon" value={filters.commune} onChange={(e) => onChange('commune', e.target.value)} className="input-field" data-testid="zone-filter-commune" />
      </div>
      <p className="text-sm text-[#4B5563]" data-testid="zones-count">{total} zone{total > 1 ? 's' : ''} affichée{total > 1 ? 's' : ''}</p>
      {!access && (
        <Button asChild className="w-full bg-[#F59E0B] hover:bg-[#D97706] text-white" data-testid="zone-upgrade-btn">
          <Link to={loggedIn ? '/dashboard/subscription' : '/register'}><Crown className="w-4 h-4 mr-2" /> {loggedIn ? 'Passer Premium' : 'Créer un compte Premium'}</Link>
        </Button>
      )}
    </CardContent>
  </Card>
);
